export default {
  resource: {
    zh: {
      title: "微信页面权限",
      mcardp: "更新权限",
      apply_dept: "申请部门",
      user_no: "员工编号",
      apply_day: "申请时间",
      apply_day1: "申请开始时间",
      apply_day2:"申请结束时间",
      apply_repair_des: "损坏情况",
      apply_des_auditing: "申请审核人",
      day_hope_finish: "期望修复时间",
      deal_dept: "处理部门",
      day_repeat_finish: "预计修复时间",
      deal_remark: "维修描述",
      deal_auditing_user: "申请处理人",
      deal_user: "维修人",
      day_finish: "修复时间",
      remark: "复核",
      xm: "员工姓名",
      state: "未用",
      adderId: "登录用户ID",
      addTime: "添加记录时间",
      canuse: "未用",
      apply_img: "未用",
      autoid:"流水编号",
      user_no: "工号",
      empName: "姓名",
      chongzhi: "充值",
      baocan: "报餐",
      qingjia: "请假",
      paiche: "派车",
      weixiu: "维修",
      chuchai: "出差",
      buka: "补卡",
      Save: "确认",
      tel:"电话",
      is_page:"页面权限",
      reg_date:"登记日期",
      deptNo:"部门编号",
      deptname:"部门名称",
      result_img: "未用"
    }
  },
  delConf: ["autoid"],
  delKeys: ["autoid"],
  params: {
    user_no: {
      key: "user_no",
      data: null,
      method: "Equal",
      type: "text"
    },
    xm: {
      key: "xm",
      data: null,
      method: "Contains",
      type: "text"
    }
    
  },
  listDefine: [
    {key:"autoid",width:"120px"},
    {key:"deptNo", width:"100px"},
    {key:"deptname", width:"100px"},
    {key:"user_no", width:"100px"}, 
    "xm",
     "tel", 
    {key:"reg_date", formatter:"fdateTime", width:"130px"}, 
    {key:"is_page",  width:"60px"},
    {key:"chongzhi",  width:"60px"},
    {key:"baocan",  width:"60px"},
    {key:"qingjia",  width:"60px"},
    {key:"paiche",  width:"60px"},
    {key:"weixiu",  width:"60px"},
    {key:"chuchai",  width:"60px"},
    {key:"buka",  width:"60px"}
  ],
  bodyClass: "table-select", //table-multiselect table-select
  list: [],
  defaultSortName: "deptname",
  defaultSortOrder: "asc",
  sortName: "deptname",
  sortOrder: "asc",
  pageNo: 1,
  pageSize: 18,
  rowCount: 127,
  url: "weixin/",
  autoId: "autoid"
}
